import React, { useState, useEffect } from 'react';
import classes from './ProductList.module.scss';
import { connect, useDispatch } from 'react-redux';
import { Row, Col, Empty, Input, Grid } from 'antd';
import ProductBlock from './ProductBlock';
import { getProducts, getCategories } from '../../http/products';
import { useTranslation } from 'react-i18next';
import Button from '../UI/Button/Button';
import { SearchOutlined, CloseOutlined, DownOutlined } from '@ant-design/icons';

const PAGE_SIZE = 8;

const ProductList = ({ storageProducts, categories, activeCategory }) => {
  const [filter, setFilter] = useState('');
  const [products, setProducts] = useState(storageProducts);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const breakpoints = Grid.useBreakpoint();

  const fetchProducts = (categoryId, pageNum = 1, search = '', append = false) => {
    dispatch(getProducts(categoryId, pageNum, PAGE_SIZE)).then((res) => {
      const items = search
        ? res.data.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()))
        : res.data;
      setProducts((prev) => (append ? [...prev, ...items] : items));
      setTotal(res.total);
      setPage(pageNum);
    });
  };

  useEffect(() => {
    if (!categories.length)
      dispatch(getCategories());
  }, [])

  useEffect(() => {
    fetchProducts(activeCategory?.id, 1);
    setFilter('');
  }, [activeCategory]);

  const setActiveCategory = (category) => {
    dispatch({ type: 'Products/SET_ACTIVE_CATEGORY', payload: category });
  }

  const onSearch = () => {
    fetchProducts(activeCategory?.id, 1, filter);
  };

  const onShowMore = () => {
    fetchProducts(activeCategory?.id, page + 1, filter, true);
  };

  const onCategoryClick = (category) => {
    if (activeCategory?.id === category?.id) {
      setActiveCategory(null);
    } else {
      setActiveCategory(category);
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ width: '100%', display: 'flex', gap: 10 }}>
          <Input
            placeholder={t('pages.main.marketplace.search')}
            size='large'
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSearch()}
            style={{
              width: '100%',
              borderRadius: 24,
              borderColor: 'black',
              padding: '10px 30px'
            }}
          />
          <Button onClick={onSearch} style={{ padding: breakpoints.xs ? '10px 15px' : '15px 30px'}}>
            {breakpoints.xs ? <SearchOutlined /> : t('pages.main.marketplace.search')}
          </Button>
        </div>
        <div className={classes.categories}>
          {categories.map((item) => (
            <div
              key={item.id}
              onClick={() => onCategoryClick(item)}
              className={`${classes.categories__item} ${activeCategory?.id === item.id ? classes.active : ''}`}
            >
              {i18n.language === 'en' ? item.name : item.name_lv}
              {activeCategory?.id === item.id && (
                <CloseOutlined className={classes.categories__close} />
              )}
            </div>
          ))}
        </div>
      </div>
      <h4 style={{ marginBottom: 40, marginTop: 60 }}>
        {t('pages.main.marketplace.subtitle')}
      </h4>
      {products?.length ? (
        <Row gutter={[20, 20]}>
          {products.map((item) => (
            <Col xs={24} sm={12} md={12} xl={6} xxl={6} key={item.id}>
              <ProductBlock {...item} id={item.t_product_id} />
            </Col>
          ))}
        </Row>
      ) : (
        <Empty
          description={t('etc.notFound')}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
      {page * PAGE_SIZE < total && (
        <div className={classes.showMore}>
          <button type='button' className={classes.showMore__button} onClick={onShowMore}>
            <span className={classes.showMore__text}>{t('pages.main.marketplace.showMore')}</span>
            <DownOutlined className={classes.showMore__arrow} />
          </button>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  storageProducts: state.games.products,
  categories: state.games.categories,
  activeCategory: state.games.activeCategory,
});

export default connect(mapStateToProps)(ProductList);
